@if (card) {
  <mat-card class="summary-card">
    <mat-card-content class="summary-card__content">
      <div class="summary-card__row summary-card__row--margin-bottom">
        @for (dataItem of card.data; track $index) {
          <div class="summary-block" [ngClass]="'summary-block--' + dataItem.heading.toLowerCase().replaceAll(' ', '-')">
            <mat-card-subtitle class="summary-block__subtitle">
              {{ dataItem.heading }}
              <mat-icon [matTooltip]="dataItem.infoTipText" matTooltipPosition="above" class="summary-block__icon"
                ><span class="material-symbols-outlined summary-block__subtitle--infoicon">info</span></mat-icon
              >
            </mat-card-subtitle>
            <mat-card-title class="summary-block__title" [class.summary-block--warning]="dataItem.valueStatus === 'negative'">
              {{ dataItem | cardValue }}
            </mat-card-title>
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
}
